import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/mk/501/',
    component: ComponentCreator('/mk/501/', '1a3'),
    exact: true
  },
  {
    path: '/mk/articles/',
    component: ComponentCreator('/mk/articles/', 'a9e'),
    exact: true
  },
  {
    path: '/mk/articles/2024/07/09/diskusija-lj-nj-cyrl/',
    component: ComponentCreator('/mk/articles/2024/07/09/diskusija-lj-nj-cyrl/', '19e'),
    exact: true
  },
  {
    path: '/mk/articles/2024/07/09/diskusija-lj-nj/',
    component: ComponentCreator('/mk/articles/2024/07/09/diskusija-lj-nj/', '21b'),
    exact: true
  },
  {
    path: '/mk/articles/archive/',
    component: ComponentCreator('/mk/articles/archive/', 'a53'),
    exact: true
  },
  {
    path: '/mk/articles/authors/',
    component: ComponentCreator('/mk/articles/authors/', 'd8e'),
    exact: true
  },
  {
    path: '/mk/search/',
    component: ComponentCreator('/mk/search/', 'f4e'),
    exact: true
  },
  {
    path: '/mk/',
    component: ComponentCreator('/mk/', '93a'),
    exact: true
  },
  {
    path: '/mk/',
    component: ComponentCreator('/mk/', '70f'),
    routes: [
      {
        path: '/mk/',
        component: ComponentCreator('/mk/', '458'),
        routes: [
          {
            path: '/mk/tags/',
            component: ComponentCreator('/mk/tags/', 'b18'),
            exact: true
          },
          {
            path: '/mk/tags/comparative/',
            component: ComponentCreator('/mk/tags/comparative/', '386'),
            exact: true
          },
          {
            path: '/mk/tags/grammar/',
            component: ComponentCreator('/mk/tags/grammar/', '1d4'),
            exact: true
          },
          {
            path: '/mk/tags/interslavic/',
            component: ComponentCreator('/mk/tags/interslavic/', '416'),
            exact: true
          },
          {
            path: '/mk/tags/language-learning/',
            component: ComponentCreator('/mk/tags/language-learning/', '888'),
            exact: true
          },
          {
            path: '/mk/tags/linguistics/',
            component: ComponentCreator('/mk/tags/linguistics/', '275'),
            exact: true
          },
          {
            path: '/mk/tags/personal-pronouns/',
            component: ComponentCreator('/mk/tags/personal-pronouns/', '39a'),
            exact: true
          },
          {
            path: '/mk/tags/pronouns/',
            component: ComponentCreator('/mk/tags/pronouns/', 'b0b'),
            exact: true
          },
          {
            path: '/mk/tags/slavic-languages/',
            component: ComponentCreator('/mk/tags/slavic-languages/', '758'),
            exact: true
          },
          {
            path: '/mk/tags/граматика/',
            component: ComponentCreator('/mk/tags/граматика/', '7ec'),
            exact: true
          },
          {
            path: '/mk/tags/заменки/',
            component: ComponentCreator('/mk/tags/заменки/', '50c'),
            exact: true
          },
          {
            path: '/mk/tags/меѓуславјански-јазик/',
            component: ComponentCreator('/mk/tags/меѓуславјански-јазик/', '888'),
            exact: true
          },
          {
            path: '/mk/tags/меѓусловенски/',
            component: ComponentCreator('/mk/tags/меѓусловенски/', '42d'),
            exact: true
          },
          {
            path: '/mk/tags/споредба-на-јазици/',
            component: ComponentCreator('/mk/tags/споредба-на-јазици/', '15f'),
            exact: true
          },
          {
            path: '/mk/tags/учење-јазик/',
            component: ComponentCreator('/mk/tags/учење-јазик/', 'fcd'),
            exact: true
          },
          {
            path: '/mk/',
            component: ComponentCreator('/mk/', '495'),
            routes: [
              {
                path: '/mk/learn/faq/',
                component: ComponentCreator('/mk/learn/faq/', '09b'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/grammar/',
                component: ComponentCreator('/mk/learn/grammar/', '706'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/grammar/adjectives/',
                component: ComponentCreator('/mk/learn/grammar/adjectives/', '1a5'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/grammar/conjunctions/',
                component: ComponentCreator('/mk/learn/grammar/conjunctions/', 'd39'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/grammar/nouns/',
                component: ComponentCreator('/mk/learn/grammar/nouns/', '437'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/grammar/numerals/',
                component: ComponentCreator('/mk/learn/grammar/numerals/', '52d'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/grammar/prepositions/',
                component: ComponentCreator('/mk/learn/grammar/prepositions/', '01b'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/grammar/pronouns/',
                component: ComponentCreator('/mk/learn/grammar/pronouns/', '5b9'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/grammar/syntax/',
                component: ComponentCreator('/mk/learn/grammar/syntax/', 'e34'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/grammar/verbs/',
                component: ComponentCreator('/mk/learn/grammar/verbs/', '9b7'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/introduction/',
                component: ComponentCreator('/mk/learn/introduction/', 'a93'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/misc/constructed-slavic-languages/',
                component: ComponentCreator('/mk/learn/misc/constructed-slavic-languages/', '33f'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/misc/design-criteria/',
                component: ComponentCreator('/mk/learn/misc/design-criteria/', '50a'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/misc/history/',
                component: ComponentCreator('/mk/learn/misc/history/', '87d'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/misc/language-comparison/',
                component: ComponentCreator('/mk/learn/misc/language-comparison/', '5ff'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/misc/numbers-1-10/',
                component: ComponentCreator('/mk/learn/misc/numbers-1-10/', 'cca'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/misc/pan-slavic-relay/',
                component: ComponentCreator('/mk/learn/misc/pan-slavic-relay/', 'd5e'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/misc/personal-pronouns/',
                component: ComponentCreator('/mk/learn/misc/personal-pronouns/', '054'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/orthography/',
                component: ComponentCreator('/mk/learn/orthography/', 'd30'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/phonology/',
                component: ComponentCreator('/mk/learn/phonology/', '9b4'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/pronunciation/',
                component: ComponentCreator('/mk/learn/pronunciation/', '5ab'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/simple-grammar/',
                component: ComponentCreator('/mk/learn/simple-grammar/', '0d7'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/simple-grammar/level-1/',
                component: ComponentCreator('/mk/learn/simple-grammar/level-1/', 'f0e'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/simple-grammar/level-2/',
                component: ComponentCreator('/mk/learn/simple-grammar/level-2/', '40b'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/vocabulary/derivation/',
                component: ComponentCreator('/mk/learn/vocabulary/derivation/', '53c'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/vocabulary/flavourisation/',
                component: ComponentCreator('/mk/learn/vocabulary/flavourisation/', 'a70'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/learn/vocabulary/word-formation/',
                component: ComponentCreator('/mk/learn/vocabulary/word-formation/', '001'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/mk/resources/',
                component: ComponentCreator('/mk/resources/', '85b'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/mk/resources/applets/',
                component: ComponentCreator('/mk/resources/applets/', '6f5'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/mk/resources/applets/intelligibility/',
                component: ComponentCreator('/mk/resources/applets/intelligibility/', 'd08'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/mk/resources/applets/transliterator/',
                component: ComponentCreator('/mk/resources/applets/transliterator/', '67b'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/mk/resources/keyboards/',
                component: ComponentCreator('/mk/resources/keyboards/', '991'),
                exact: true,
                sidebar: "resourcesSidebar"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
